<section>
  <div class="header astral-page-header">
    <h1>{{ 'DASHBOARD.MENU.REPORT_RENTAL_OBJECT_RENT_LOSS' | translate }}</h1>
    <div class="astral-page-header__actions">
      <astral-button variant="primary" size="small" type="button" icon="print" labelKey="PRINT_BTN" (click)="onPrintPages()"></astral-button>
    </div>
  </div>

  <form class="filter astral-section-surface astral-form-stack astral-form-stack--relaxed report-filter-surface" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <astral-layout-group [columns]="6" [tabletColumns]="2" [mobileColumns]="1">
      <astral-select [control]="form.controls['company']" [itemsSource]="companies"></astral-select>
      <astral-select [control]="form.controls['property']" [itemsSource]="realEstateProperties"></astral-select>
      <astral-date-picker [control]="form.controls['from']" [model]="from" [label]="'REPORT.RENT_LOSS_FROM'" [isRequired]="true"></astral-date-picker>
      <astral-date-picker [control]="form.controls['to']" [model]="to" [label]="'REPORT.RENT_LOSS_TO'" [isRequired]="true"></astral-date-picker>
    </astral-layout-group>
    <div class="astral-filter-actions">
      <astral-button variant="primary" size="small" type="submit" icon="search" labelKey="SEARCH_BTN"></astral-button>
      @if (dataContext && dataContext.length) {
        <astral-button
          variant="secondary"
          size="small"
          type="button"
          [labelKey]="!expandAllRows ? 'COMMON.EXPAND_ALL' : 'COMMON.COLLAPSE_ALL'"
          (click)="toggleExpandAllRows()"
        ></astral-button>
      }
    </div>
  </form>

  @if (dataContext) {
    <app-expanded-list-view
      [columnDefinitions]="columnDefinitions"
      [itemsSource]="dataContext"
      [expandAllRows]="expandAllRows"
      [preferencesKey]="'report.rental-object-rent-loss'"
    ></app-expanded-list-view>
  }
</section>
